import script from "./tagViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./tagViewer.vue?vue&type=script&setup=true&lang=ts"

import "./tagViewer.vue?vue&type=style&index=0&id=0e8fb468&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e8fb468"]])

export default __exports__